import RelatedSearches from './related-searches';

export default RelatedSearches;
